// extracted by mini-css-extract-plugin
export default {"window":"styles_window__iRz-g","wrapper":"styles_wrapper__2xA8X","title":"styles_title__rjfFR","content":"styles_content__zf+uU","deleteIcon":"styles_deleteIcon__Ywctq"};